export default __webpack_public_path__ + "static/media/hand.19217cc6.png";